function createDetail(sourceCard, explanation, facts) {
  return Object.freeze({
    sourceCard,
    explanation: Object.freeze(explanation),
    facts: Object.freeze(
      facts.map(([label, value]) => Object.freeze({ label, value })),
    ),
  });
}

export const INFOCARD_DETAILS = Object.freeze({
  fluessigbodenAllg: createDetail(
    1,
    [
      "Das Produkt Flüssigboden nutzt als Basiszugschlagstoff zur Ressourcenschonung möglichst immer den auf der Baustelle vorhandenen Bodenaushub und verwandelt diesen in einen technisch definierbaren Verfüllbaustoff. Mit diesem Verfahren besteht die Möglichkeit, dass oftmals nicht wieder einbaubarer Bodenaushub wiederverwendet werden kann und weniger frisch zugelieferter Boden, Sand oder Kies anfällt.",
      "Im Einbau verteilt sich der Flüssigboden selbstständig, füllt Hohlräume nahezu schwindungsfrei aus und sorgt für eine gleichmäßige, verdichtungsfrei und bodengleiche Struktur. Der Einbau erfolgt somit vibrationsfrei.",
      "Gleichzeitig härtet der Flüssigboden im Gegensatz zu anderen Verfüllbaustoffen (z.B. „Dämmern“) nur so weit aus, dass er im ausgehärteten Zustand leicht lösbar bleibt. So können auch nach Jahren beispielsweise Leitungen, Kanäle oder auch andere Bauteile wieder freigelegt werden. Der dabei ausgehobene, wiedergewonnene Flüssigboden kann dabei mehrfach als Flüssigboden wiederverwertet werden.",
      "Der Einbau in wasserschutzrelevanten Bereichen sowie auch im Grundwasser ist dabei erlaubt, selbst wenn oftmals auch Schadstoffe im Aushubboden vorhanden sind. Alle eingesetzten Komponenten des Flüssigbodens sind nachweisebar unbedenklich. Darüber hinaus besteht die Möglichkeit, über die VDI 3898 mögliche Schadstoffe aus dem ursprünglichen Bodenaushub im Produkt zu binden und ein Auswaschen in das Grundwasser zu verhindern.",
    ],
    [
      ["Materialbasis", "Bodenaushub, Wasser, Zement und Compound"],
      ["Konsistenz", "Fließfähig beim Einbau"],
      ["Begehbarkeit", "nach ca. 12 Stunden (bei 20°C Aussentemperatur)"],
      ["Überbaubarkeit", "Nach ca. 24 Stunden (bei 20°C Aussentemperatur)"],
      ["Rückbau", "Auch nach Jahren wieder lösbar"],
      ["Festigkeit", "Definiert einstellbar"],
      [
        "Einbauvorteile",
        "Setzungssichere, vibrations- und schadensfreie Verfüllung",
      ],
    ],
  ),
  bagger: createDetail(
    2,
    [
      "Nicht jeder Boden verhält sich gleich. Kiese, sandige Böden, Tone und Schluffböden, Klei- und zum Teil auch Torfböden, RC-Material und sogar Bohrschlämme können grundsätzlich verarbeitet werden, wenn sie für die Anlage und die Rezeptur passend vorbereitet werden. Grenzen entstehen vor allem dort, wo Inhaltsstoffe wie Huminsäuren oder Gipsanteile die Aushärtung aktuell noch beeinflussen können. Deshalb ist es notwendig, dass jeglicher Boden vor dem Einsatz geprüft und technisch bewertet wird.",
      "Im Praxisbeispiel erhält Flüssigboden OWL ca. 100 kg des Bodens und erstellt im ersten Schritt eine Kurzrezeptur. Hierbei wird der Boden dahingehend getestet, dass die gewünschte Aushärtung stattfindet. Dies ist bereits am darauffolgenden Tag meistens möglich. Sollten höhere Anforderungen an das Endprodukt bestehen, so wird im Anschluss eine umfängliche Rezepturentwicklung / Eignungsprüfung vorgenommen. Für den Nachweis späterer Tragfähigkeiten empfiehlt es sich oft, eine Probefläche vor Ort anzulegen.",
    ],
    [
      [
        "Bodenarten",
        "Kiese und Sande, Tone, Schluffe, Klei- und Torfböden, RC-Material, etc.",
      ],
      [
        "Sondermaterial",
        "HDD-Bohrschlämme, chemisch belastete Böden, Hafenschlick, etc.",
      ],
      [
        "Grenze",
        "Huminsäuren (aktuell), Gipse im Boden (hohes Quellverhalten)",
      ],
      [
        "Prüfung",
        "Kurzrezeptur, Rezepturentwicklung / Eignungsprüfung, Probefläche",
      ],
      ["Ziel", "komplette Wiederverwertung des vor Ort vorhandenen Bodens"],
      [
        "Vorteil",
        "Weniger Entsorgung und weniger Fremdmaterial; Co2-Einsparung",
      ],
    ],
  ),
  schadstoffbindung: createDetail(
    13,
    [
      "Bei belasteten Böden geht es darum, Schadstoffe im eingebauten Festkörper zu binden und dadurch die Auswaschung zu reduzieren. Die Schadstoffe verschwinden nicht, sondern bleiben im Boden gebunden, solange der Flüssigboden als Festkörper erhalten bleibt. Für solche Anwendungen braucht es eine geprüfte Rezeptur, Laborwerte und häufig eine Abstimmung mit Behörden. Genannt wurden im Meeting unter anderem PAK, PFAS und Arsen.",
    ],
    [
      ["Schadstoffe", "PAK, PFAS, Arsen und weitere Stoffgruppen"],
      ["Ziel", "Schadstoffe im Festkörper binden"],
      ["Testdauer", "Aktuell ca. 28 Tage genannt"],
      ["Nachweis", "Trockeneluat am Festkörper"],
      ["Vorteil", "Weniger Entsorgung belasteter Böden"],
      ["Hinweis", "Baugrundrisiko bleibt beim Bauherrn"],
    ],
  ),
  mischer: createDetail(
    7,
    [
      "Die Produktion beginnt mit dem vorhandenen Aushub. Ein Bagger oder Radlader beschickt die Anlage, anschließend werden Boden, Wasser, Zement und Compound exakt dosiert. Je nach Baustellensituation wird der Flüssigboden direkt in einer Mischschnecke fertig produziert oder über ein Förderband in einen Fahrmischer gegeben. Entscheidend ist, dass alle Bestandteile gleichmäßig und kontrolliert zusammengeführt werden. So wird ein bestmöglich homogener Baustoff produziert.",
    ],
    [
      ["Produktionsort", "Direkt auf der Baustelle"],
      ["Beschickung", "Mit Bagger oder Radlader"],
      ["Dosierung", "Boden, Wasser, Zement und Compound"],
      ["Leistung", "bis zu 100 m³/h"],
      ["Kontrolle", "Permanente Verwiegung sichert die Qualität"],
      [
        "Varianten",
        "Mischschnecke, Fahrmischerbeschickung, Trockenmischung",
      ],
      [
        "Ziel",
        "höchste Effizienz, höchste Leistung bei bester Materialqualität",
      ],
      ["Pumpfähigkeit", "> 300 m bei passender Rezeptur"],
    ],
  ),
  waermeleitfaehigkeit: createDetail(
    15,
    [
      "Wärmeleitfähigkeit wird im modernen Tiefbau immer wichtiger. Leitungen und Kollektoren profitieren davon, wenn Wärme zuverlässig aufgenommen, abgeführt oder gespeichert werden kann. Flüssigboden OWL kann Böden so aufbereiten und rezeptieren, dass eine definierte Wärmeleitfähigkeit erreicht und nachgewiesen werden kann. Im Meeting wurde eine Wärmeleitfähigkeit von über 2,5 W/(m·K) als mögliche Zielgröße genannt.",
    ],
    [
      ["Anwendung", "Stromtrassen, Fernwärme und Geothermie"],
      ["Zielwert", "Über 2,5 W/(m·K) möglich"],
      ["Nachweis", "Wärmeleitfähigkeit prüfbar"],
      ["Vorteil", "Bessere Wärmeübertragung im Boden"],
      ["Einsatz", "Auch für Energiemonolithen relevant"],
      ["Steuerung", "Über Sieblinie und Rezeptur"],
    ],
  ),
  arbeitsraumverfuellung: createDetail(
    10,
    [
      "Hohlräume sind im klassischen Tiefbau oft schwierig zu verfüllen, weil die Verdichtung kaum möglich ist oder Personal in enge Bereiche muss, die oftmals einsturzgefährdet sind. Flüssigboden löst dieses Problem, weil er fließfähig eingebracht wird, sich gut verteilt und im Anschluss ohne weitere Maßnahmen schwindungsfrei refixiert. So können Hohlräume gleichmäßig geschlossen werden, ohne dass Hohl- oder Fehlstellen oder gar unverdichtete Bereiche zurückbleiben. Besonders im Bereich einsturzgefährdeter Tage- und Untertagebrüchen, in engen Arbeitsräumen, Schächten und schwer zugänglichen Bauabschnitten stellt dies einen großer Vorteil dar.",
    ],
    [
      [
        "Anwendung",
        "Hohlräume, Tage- & Untertagebrüche, Kanalverfüllungen und für Personal schwer zugängliche Arbeitsräume",
      ],
      [
        "Einbau",
        "Durchlaufmischverfahren direkt oder über eine Flüssigbodenpumpe ins Bauteil",
      ],
      ["Verdichtung", "Nicht erforderlich"],
      [
        "Ergebnis",
        "statisch tragfähig, direkte Kraftübertragung, kein Schwindverhalten, bei Bedarf wieder aushubfähig",
      ],
      [
        "Vorteil",
        "direkte Kraftübertragung, keine Gefährdung von Personal, hohe Einbaugeschwindigkeit; wieder Aushubfähig",
      ],
      ["Nutzen", "Sicherer und schneller Bauablauf in engen Bereichen"],
    ],
  ),
  einbau: createDetail(
    9,
    [
      "Beim Einbau muss beim Flüssigboden nicht darauf geachtet werden, dass ein lagenweiser Einbau mittels entsprechenden Verdichtungsenergie erfolgt. Auch ist eine Verdichtung mittels „Betonrüttler“ nicht notwendig. Der Flüssigboden fließt in Hohlräume, Zwickelbereiche und Zwischenräume und legt sich gleichmäßig an Leitungen, Rohre oder andere Bauteile ohne Schwindverhalten an. Und das ohne produktspezifische Einschränkungen an die direkte Verfüllhöhe. Bei Bedarf kann er über Betonpumpen transportiert werden, und das auch über längere Strecken >300 m. Dadurch eignet sich Flüssigboden u.a. besonders für Baugruben, Kanäle, Arbeitsräume, und schwer zugängliche Einbaubereiche wie z.B. alte einsturzgefährdete Stollen oder nicht befahrbare Lastausgleichsplatten.",
    ],
    [
      ["Einbauart", "Fließfähig und selbstverteilend"],
      ["Verdichtung", "Keine lagenweise Verdichtung nötig"],
      ["Pumpstrecke", ">300 Meter möglich"],
      ["Schichtstärke", "Mehrere Meter in einem Gang möglich"],
      ["Einsatzort", "Baugruben, Hohlräume und Leitungsgräben, etc."],
      [
        "Vorteil",
        "Weniger Personal in engen Baugruben, keine Verdichtung, kein Schwindverhalten, Gefährdungsminimierung für das Einbaupersonal",
      ],
    ],
  ),
  kanalbau: createDetail(
    11,
    [
      "Gerade im Kanalbau entstehen häufig Beschädigungen während des Einbaus. Auch spätere Setzungen, Dellen oder Absackungen auf Grund von schwer zu verdichtenden Zwickelbereichen unter Rohren oder im Bereich nicht tragfähiger Bettungswiderlager können komplett eliminiert werden. Flüssigboden fließt genau in diese Bereiche und sorgt für eine gleichmäßige Bettung ohne lagenweise Verdichtung und minimiert die Einbauenergie, welche beim Verdichten auf den einzubauenden Kanal/Rohre entsteht. Zusätzlich können mehrere Rohre gleichzeitig eingebaut und verfüllt werden, wodurch komplexe Stufenkanäle vermieden werden können. Nach ca. 24 Stunden kann der Bereich wieder überbaut werden.",
    ],
    [
      ["Anwendung", "Kanal- und Rohrleitungsbau"],
      ["Sandbettung", "Durch Flüssigboden ersetzbar"],
      [
        "Rohre",
        "Mehrere Rohre in einem Einbaubereich gleichzeitig möglich",
      ],
      ["Überbaubarkeit", "Nach ca. 24 Stunden"],
      [
        "Setzungen",
        "Zwickelbereiche werden gleichmäßig verfüllt, kein Bettungswiderlager notwendig",
      ],
      [
        "Vorteil",
        "keine Beschädigungen, weniger Entsorgung und weniger Fremdmaterial, kein Bettungswiderlager",
      ],
    ],
  ),
  lastenausgleichschicht: createDetail(
    12,
    [
      "Bei schwachen oder ungleichmäßigen Untergründen ist die klassische Verdichtung oft problematisch, weil das Verdichten den anstehenden Boden stark beansprucht. Flüssigboden wird dagegen ohne den Einsatz von mechanischer Verdichtung eingebracht. Dadurch können unnötige Setzungen homogenisiert und tragfähige Lastausgleichsschichten aufgebaut werden. Oft kann Flüssigboden als Ersatz für zementgebundene Tragschichten ersetzen oder ergänzen.",
      "Praxisbeispiel:",
      "In einem Logistikzentrum in Hamburg sollte über bereits eingebauten CMC-Säulen im Erdreich eine zementgebundene Lastausgleisschicht aus frisch geliefertem Magerbeton erstellt werden. Gleichzeitig musste dafür überschüssiger, schadstoffbelasteter Bodenaushub entsorgt werden. Flüssigboden OWL konnte in diesem Fall für den Bauherren eine passende Rezeptur finden, um diese Ausgleichsschicht über den Einsatz von Flüssigboden mit dem vor Ort vorhandenen Boden zu realisieren. Die Einsparungen lagen in diesem Fall bei einer hohen sechsstelligen Zahl.",
    ],
    [
      [
        "Anwendung",
        "Hallenbau, Deichbau, Straßenbau und Untergrundverbesserung",
      ],
      ["Funktion", "Lasten gleichmäßiger verteilen"],
      ["Setzungen", "Homogenisieren"],
      ["Verdichtung", "Keine mechanische Verdichtung nötig"],
      ["Alternative", "Ersatz für zementgebundene Tragschichten"],
      ["Vorteil", "Nutzung des Erdreichs vor Ort"],
    ],
  ),
  energiemonolith: createDetail(
    17,
    [
      "Beim Energiemonolithen werden Kollektoren im Boden eingebettet, die Wärme aufnehmen und an eine Wärmepumpe weitergeben. Der Boden liefert ganzjährig relativ stabile Temperaturen und kann im Sommer durch überschüssige Wärme wieder regeneriert werden. In Kombination mit Flüssigboden können Kollektoren dauerhaft geschützt eingebettet werden; sogar der Einbau unter Gebäuden wird möglich, weil Hebungen und Setzungen kontrolliert werden können.",
    ],
    [
      ["Energiequelle", "Oberflächennahe Geothermie"],
      ["Effizienz", "1 kWh Strom zu ca. 4,5–5,5 kWh Wärme"],
      ["Flächenregel", "Ca. 50 m² für ca. 150 m² Beheizfläche"],
      ["Einbautiefe", "Unterkante ca. 1,40 Meter genannt"],
      ["Nutzung", "Heizen, Kühlen und Regeneration"],
      ["Flächen", "Sportplätze, Hallen, Parkplätze und Gebäude"],
    ],
  ),
  rezeptur: createDetail(
    4,
    [
      "Flüssigboden funktioniert nicht nach einem universellen Standardrezept. Die Rezeptur richtet sich nach den jeweiligen, baustellen- und bodenspezifischen Bedürfnissen. Bodenart, Einbausituation, gewünschter Festigkeit, Wärmeleitfähigkeit, Wasserdurchlässigkeit, Volumenstabilität oder auch die Bindung von Schadstoffen sind nur ein Teil der möglichen, geforderten Eigenschaften. Über eine Schnellrezeptur kann dabei früh geprüft werden, ob der Boden grundsätzlich nutzbar ist. Für anspruchsvolle Projekte wird daraus eine belastbare Rezeptur mit technischen Nachweisen entwickelt, die am Ende auch statischen Anforderungen standhält.",
      "Im Praxisbeispiel erhält Flüssigboden OWL ca. 100 kg des Bodens und erstellt im ersten Schritt eine Kurzrezeptur. Hierbei wird der Boden dahingehend getestet, dass die gewünschte Aushärtung stattfindet. Dies ist bereits am darauffolgenden Tag meistens möglich. Im Anschluss erfolgt die Rezepturentwicklung / Eignungsprüfung nach Vorgabe der aktuellen Normung/Vorgaben. Für praxisorientierte Nachweise, z.B. der späteren Tragfähigkeiten ermittelt über statische Lastplattendruckversuche empfiehlt es sich oft, eine Probefläche vor Ort anzulegen.",
    ],
    [
      [
        "Rezeptur",
        "Baustellenbezogen auf Basis aktueller Normung / Vorschriften",
      ],
      ["Schnellprüfung", "Erste Aussage meist am nächsten Tag"],
      ["Parameter", "Wasser, Zement, Compound und Boden"],
      [
        "Zielwert",
        "Festigkeit, Volumenstabilität, Wasserdurchlässigkeit, Schadstoffbindung, etc.",
      ],
      [
        "Anpassung",
        "bodenspezifische Rezepturanpassung an bauseitige Bedürfnisse",
      ],
      ["Ergebnis", "Reproduzierbare Flüssigbodenqualität"],
    ],
  ),
});

export function getInfocardDetail(cardName) {
  return INFOCARD_DETAILS[cardName] ?? null;
}
